<template>
    <div class="main">
        <MyHeader index="5"></MyHeader>
        <div class="titleIfo">
            
            <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
                <h2>新闻</h2>
                <h3>News</h3>
            </div>
            <div class="container" v-if=" this.$i18n.locale == 'en_US'">
                <h2>News</h2>
                <h3>新闻</h3>
            </div>
        </div>
        <div class="newsInfo">
            <div class="container">
                <div class="content">
                    <div class="leftMenu" id="menu">
                        <ul>
                           
                            <li :class="{'on':page.category_id == 70}" :cid="70">
                                <i>{{$t('news.activity')}}</i>
                                <b></b>
                            </li>
                             <li :class="{'on':page.category_id == 69}" :cid="69">
                                <i>{{$t('news.Release')}}</i>
                                <b></b>
                            </li>
                            <li :class="{'on':page.category_id == 71}" :cid="71">
                                <i>{{$t('news.Past period')}}</i>
                                <b></b>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                           <ul  v-if=" this.$i18n.locale == 'zh_CN'">
                                <li v-for="(item,i) in newsList">
                                    <router-link :to="{name:'newsInfo',params:{id:item.id}}">
                                        <div class="newsImg">
                                            <img :src="item.thumb_image" alt="newsImg">
                                        </div>
                                        <div class="newText">
                                            <h3 >{{item.name}}</h3>                                
    	                                    <p >{{item.brief}}</p>
                                            <h6>{{$t('label.release')}}{{item.release_time}}</h6>
                                            
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                            
                             <ul  v-if=" this.$i18n.locale == 'en_US'">
                                <li v-for="(item,i) in newsList">
                                    <router-link :to="{name:'newsInfo',params:{id:item.id}}">
                                        <div class="newsImg">
                                            <img :src="item.thumb_image" alt="newsImg">
                                        </div>
                                        <div class="newText">
                                            <h3 >{{item.name_en}}</h3>
                                            <p >{{item.brief_en}}</p>
                                            <h6>{{$t('label.release')}}{{item.release_time}}</h6>
                                            
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                            
                        <pagination :pageInfo="pageInfo" @change="pagechange"></pagination>
                    </div>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader'
    import MyFooter from './common/MyFooter'
    import pagination from './common/vue-pagination'
    import filter from '../filter.js';
    import {createArticle, getArticleList, getArticleDetails, deleteArticle, putArticle} from '@/services/article';

    export default {
        name: "NewsPage",
        components: { MyHeader,MyFooter,pagination },
        data(){
            return{
                newsList : [],
                newsList1 : [],
                newsList2 : [],
                page:{
                    page_size:5,
                    page:1,
                    category_id:69,
                    
                },
                pageInfo:{
                    total:1,        // 记录总条数   默认空，如果小于pageNum则组件不显示   类型Number
                    current:1,      // 当前页数，   默认为1                             类型Number
                    pagenum:5,      // 每页显示条数,默认10                              类型Number
                    pagegroup:3,    // 分页条数     默认为5，需传入奇数                  类型Number
                    skin:'#13AE67'  // 选中页码的颜色主题 默认为'#16a086'                类型String
                }

            }
        },
        watch:{
		  $route(to,from){
			this.page.category_id = this.$route.params.id;
			
            this.getList();
		  }
		},
        mounted(){
        	this.page.category_id = this.$route.params.id;
            this.getList();
            this.menuClick();
            
            // 记录 referer
           //  let referer = localStorage.getItem("referer");
//             if (referer == "news_detail") {
//             	let category = localStorage.getItem("category");
//             	this.page.category_id = category;
//             	
//             	localStorage.setItem("referer","news");
//             }
        },
        methods:{
            getList(){
                
                getArticleList(this.page).then(res => {
                    let list = res.items;
                   
						for(var i in list){
							let item = list[i];
							item.release_time = filter.dateFormat(item.release_time,'yyyy-mm-dd');
						}
                        this.newsList = list;
                   
                    
                    this.pageInfo.total= res._meta.totalCount;
                    this.pageInfo.current= res._meta.currentPage;
                    this.pageInfo.pagenum= res._meta.perPage;
                   
                }).catch(err => {});
            },
            pagechange(current){
                this.page.page = current;
                this.getList();
            },
            menuClick(){
                let that = this;
                $('#menu li').on('click',function () {
                	var cid = $(this).attr("cid");
                	that.$router.push('/news/'+cid)
                	
                   //  that.page.page = 1;
//                     $(this).addClass('on').siblings().removeClass('on');
//                     let index = Number($(this).index());
//                     that.page.category_id = that.categoryId(index);
//                     that.getList(function () {
//                         that.pageInfo.current = 1;
//                     });
                })
            },
           
            categoryId(id){
                let categoryId = 0;
                switch (id) {
                    case 0 : categoryId = 69; break;
                    case 1 : categoryId = 70; break;
                    case 2 : categoryId = 71; break;
                    default: categoryId = null; break;
                }
                return categoryId;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main {
        .titleIfo {
            width: 100%;
            height: 380px;
            background: url("./image/news.jpg") no-repeat center center;
            background-size: cover;

            .container {
                h2 {
                    padding-top: 180px;
                    text-align: center;
                    color: #FFFFFF;
                    height: 42px;
                    font-size: 32px;
                    font-weight: bold;
                    line-height: 42px;
                }

                h3 {
                    text-align: center;
                    height: 29px;
                    font-size: 22px;
                    line-height: 29px;
                    color: #FFFFFF;
                }
            }
        }
        .newsInfo{
            .container {
                border-top: 1px solid #E6E6E6;
                .content {
                    margin-top: 100px;
                    overflow: hidden;
                    margin-bottom: 48px;
                    .leftMenu {
                        width: 246px;
                        float: left;
                        ul {
                            li {
                                cursor: pointer;
                                padding: 0 16px;
                                border-radius: 18px;
                                height: 36px;
                                overflow: hidden;
                                line-height: 36px;
                                margin-bottom: 10px;

                                &:last-child {
                                    margin-bottom: 0;
                                }

                                i {
                                    display: inline-block;
                                    float: left;
                                    color: #252525;
                                    font-size: 16px;
                                }

                                b {
                                    display: inline-block;
                                    float: right;
                                    width: 30px;
                                    height: 100%;
                                    background: url("./image/yy2.png") no-repeat center center;
                                    background-size: 100%;
                                    line-height: 36px;
                                }

                            }

                            .on {
                                background: #13AE67;

                                i {
                                    color: #FFFFFF;
                                }

                                b {
                                    background: url("./image/yy.png") no-repeat center center;
                                    background-size: 86%;
                                }
                            }
                        }
                    }
                    .rightContent{
                        float: right;
                        ul{
                            li{
                                margin-bottom: 40px;
                                &:last-child{
                                    margin-bottom: 32px;
                                }
                                a{
                                    overflow: hidden;
                                    display: block;
                                    .newsImg{
                                        float: left;
                                        width: 216px;
                                        height: 144px;
                                        img{
                                            width: 100%;
                                        }
                                    }
                                    .newText{
                                        float: left;
                                        margin-left: 20px;
                                        width: 584px;
                                        h3{
                                            margin-top: 7px;
                                            color: #252525;
                                            height:24px;
                                            font-size:18px;
                                            font-weight:bold;
                                            line-height:24px;
                                        }
                                        p{
                                            display: block;
                                            font-size: 14px;
                                            color: #505050;
                                            line-height: 20px;
                                            height: 60px;
                                            margin-top: 16px;
                                            display: -webkit-box;
                                            -webkit-box-orient: vertical;
                                            -webkit-line-clamp: 3;
                                            overflow: hidden;
                                        }
                                        h6{
                                            margin-top: 22px;
                                            height:12px;
                                            font-size:12px;
                                            color:#A0A0A0;
                                            line-height:12px;
                                        }
                                    }
                                }
                            }
                        }

                    }
                }
            }
        }
    }
</style>
